export default {
  'ec.guide.zxbl':'Подать заявку онлайн',
  'ec.guide.zxbl.zbzc':'В настоящее время нет',
  'ec.guide.sc':'коллекция',
  'ec.guide.qxsc':'Нелюбимый',
  'ec.guide.download':'Загружать',
  'ec.guide.share':'Предоставить общий доступ',
  'ec.guide.tbfw':'Сфера применения',
  'ec.guide.blsd':'Глубина обработки',
  'ec.guide.xccs':'Количество заходов на сайт',
  'ec.guide.xccs.unit':'раз',
  'ec.guide.fdbjsx':'Установленный законом срок завершения работ',
  'ec.guide.fdbjsx.unit':'будни',
  'ec.guide.cnbjsx':'Обязательство по срокам завершения работ',
  'ec.guide.cnbjsx.unit':'будни',
  'ec.guide.jbxx':'Основная информация',
  'ec.guide.sxmc':'Название дела',
  'ec.guide.mlmc':'Имя каталога',
  'ec.guide.ssjg':'Исполнительные органы',
  'ec.guide.cnbjsxsm':'Обязательство по описанию сроков завершения работ',
  'ec.guide.wu':'не',
  'ec.guide.blsjdd':'Время и место обработки',
  'ec.guide.zxfs':'Способы получения консультации',
  'ec.guide.zxdh':'Консультационный телефон',
  'ec.guide.zxck':'Расспросы',
  'ec.guide.jdts':'Контроль за подачей жалоб',
  'ec.guide.tsdh':'Горячая линия по работе с жалобами',
  'ec.guide.tsck':'Окно рекламации',
  'ec.guide.material':'Материалы для применения',
  'ec.guide.clmc':'Название материала',
  'ec.guide.cllx':'Тип материала',
  'ec.guide.clxs':'Форма материала',
  'ec.guide.zzclfs':'Количество экземпляров бумажных материалов',
  'ec.guide.clbyx':'Материальная необходимость',
  'ec.guide.slbz':'Критерии приемлемости',
  'ec.guide.lyqd':'Исходный канал',
  'ec.guide.tbxz':'Инструкции по отчетности',
  'ec.guide.bgxz':'Загружать',
  'ec.guide.format.zz':'Бумажные материалы',
  'ec.guide.format.dz':'Электронные материалы',
  'ec.guide.format.both':'Бумажные、Электронные',
  'ec.guide.amount.original':'Исходный текст',
  'ec.guide.amount.copy':'копировать',
  'ec.guide.amount.unit':'часть',
  'ec.guide.require':'необходимый',
  'ec.guide.require.not':'Не обязательно',
  'ec.guide.yb':'Пример таблицы',
  'ec.guide.kb':'Пустой стол',
  'ec.guide.not.material':'Нет, не нужно',
}